import { useOutletContext } from "react-router-dom";
import { useCallback, useEffect, useRef, useState } from "react";
import { jobListViewByCandidate } from "@endpoints/job.service";
import LoadingAnimation from "@assets/svg/LoadingAnimation";
import CandidateRowCard from "./components/CandidateRowCard";
import FilterSection, { IFilters, sortByFilters, sortOrderFilters } from "./components/FilterSection";
import { useDebounce } from "hooks/useDebounce";

// @ts-ignore
import profileImage from '@assets/images/profilepic.png';
// @ts-ignore
import profileImage1 from '@assets/profilePic1.png';
// @ts-ignore
import profileImage2 from '@assets/profilePic2.png';
// @ts-ignore
import profileImage3 from '@assets/profilePic3.png';


const LIMIT = 25
const PAGE_LIMIT = 5

const dummyData = [
  {
    fullName: 'John Doe',
    jobTitle: 'Backend Developer',
    totalJobs: 10,
    status: 'available',
    profileImage: profileImage
  },
  {
    fullName: 'Adele Baker',
    jobTitle: 'Frontend Developer',
    totalJobs: 4,
    status: 'available',
    profileImage: profileImage1
  },
  {
    fullName: 'Darlene Robertson',
    jobTitle: 'Full Stack Developer',
    totalJobs: 1,
    status: 'available',
    profileImage: profileImage2
  },
  {
    fullName: 'Jane Cooper',
    jobTitle: 'Software Engineer',
    totalJobs: 2,
    status: 'available',
    profileImage: profileImage3
  },
  {
    fullName: 'Jenny Wilson',
    jobTitle: 'Product Manager',
    totalJobs: 2,
    status: 'expired',
    profileImage: profileImage
  },
]

const ViewByCandidate = () => {
  const context: any = useOutletContext();
  const { searchText } = context
  const scrollListRef = useRef(null)
  const sentinelRef = useRef(null);

  const [isLoading, setIsLoading] = useState(false);
  const [isLoadingMore, setIsLoadingMore] = useState(false)
  const [page, setPage] = useState(1)
  const [jobList, setJobList] = useState([])
  const [filters, setFilters] = useState<IFilters>({
    searchText: '',
    sortBy: sortByFilters[0],
    sortOrder: sortOrderFilters[0]
  })

  const debouncedSearchText = useDebounce(filters?.searchText)

  const fetchJobs = useCallback(
    async () => {
      try {
        if (page > 1) {
          setIsLoadingMore(true)
        } else {
          setIsLoading(true)
        }
        const { data, success } = await jobListViewByCandidate({
          page,
          limit: LIMIT,
          searchText: debouncedSearchText,
          sortBy: filters?.sortBy?.value,
          sortOrder: filters?.sortOrder?.value
        })
        if (success) {
          setJobList((prev) => page === 1 ? data : [...prev, ...data]);
        }
      } catch (error) {

      } finally {
        setIsLoading(false)
        setIsLoadingMore(false)
      }
    },
    [page, filters?.sortBy, filters?.sortOrder, debouncedSearchText]
  )

  const handleLoadMore = () => {
    if (page < PAGE_LIMIT)
      setPage((prev) => prev + 1)
  }

  // Init fetch
  useEffect(() => {
    fetchJobs();
  }, [fetchJobs])

  // Page reset on searchText changed
  useEffect(() => {
    setPage(1)
  }, [searchText])

  // Observer for the infinite scrolling
  useEffect(() => {
    if (!scrollListRef?.current || !sentinelRef?.current) return
    const observer = new IntersectionObserver((entries) => {
      if (entries?.[0]?.isIntersecting) {
        handleLoadMore()
      }
    }, {
      root: scrollListRef?.current,
      rootMargin: '0px',
      threshold: 1
    })

    observer.observe(sentinelRef?.current)

    return () => observer.disconnect();
  }, [isLoading, isLoadingMore])

  return (
    <div className="min-h-0 flex flex-col flex-1">
      <FilterSection
        filters={filters}
        setFilters={setFilters}
      />
      {/* List section */}
      {
        isLoading ?
          <div className="m-auto">
            <LoadingAnimation color="black" />
          </div>
          :
          dummyData?.length ?
            <div
              ref={scrollListRef}
              className="flex flex-col min-h-0 overflow-y-scroll no-scrollbar">
              {dummyData?.map((job) => {
                return (
                  <CandidateRowCard
                    data={job}
                  />
                );
              })}
              {isLoadingMore ?
                <div className="py-2 mx-auto font-medium text-light-black text-sm flex items-center gap-2"><LoadingAnimation color="black" /> Loading more data</div>
                :
                null
              }
              {/* Sentinel */}
              <div ref={sentinelRef} className="h-px" />
            </div>
            :
            <div className="m-auto font-medium text-sm text-light-black">Candidates not available.</div>
      }
    </div>
  );

};

export default ViewByCandidate;
